<script>
  import Page from '@components/page.svelte'
  import FilterBar from '@components/table/filter-bar.svelte'
  import Pagination from '@components/table/pagination.svelte'
  import Dropdown from '@components/general/dropdown.svelte'
  import GridView from '@components/live_sessions/grid-view.svelte'
  import { usePageParam } from '@hooks/use-page-param.svelte'
  import AutoEnroll from '@components/live_sessions/auto-enroll.svelte'
  import { Video, ClockArrowDown, ClockArrowUp, ArrowUpAZ, ArrowDownZA, Calendar, Clock, CheckCircle, CircleAlert, Settings, Tag as TagIcon } from 'lucide-svelte'
  import { page } from '@inertiajs/svelte'

  let { live_sessions = [], pagination, tags = [] } = $props()

  let user = $page.props.user

  let sort = usePageParam({ key: "sort", defaultValue: "oldest", items: [
    { value: "newest", label: "Most recent", icon: ClockArrowDown },
    { value: "oldest", label: "Oldest", icon: ClockArrowUp },
    { value: "az", label: "Alphabetical A-Z", icon: ArrowUpAZ },
    { value: "za", label: "Alphabetical Z-A", icon: ArrowDownZA }
  ]})

  let status = usePageParam({ key: "status", defaultValue: "upcoming", items: [
    { value: "upcoming", label: "Upcoming", icon: Calendar },
    { value: "past", label: "Past", icon: Clock },
    { value: "all", label: "Any status", icon: Calendar }
  ]})

  let tagOptions = $derived.by(() => {
    const emptyOption = { value: "", label: "All topics", icon: TagIcon }
    let options = tags.filter(t => t.count > 0).map(t => ({ value: t.id, label: `${t.name} (${t.count})`, icon: TagIcon }))
    return [emptyOption, ...options]
  })

  let tag = usePageParam({ key: "tag", items: tagOptions })

  let registration = usePageParam({ key: "registration", defaultValue: "all", items: [
    { value: "all", label: "Any registration", icon: Calendar },
    { value: "registered", label: "Registered", icon: CheckCircle },
    { value: "unregistered", label: "Unregistered", icon: CircleAlert },
  ]})

  let pageProps = {
    pageTitle: "Live Sessions",
    title: "Live Quarterly Member Sessions",
    subtitle: "Collaborate with other members and share learning",
    Icon: Video,
    adminActions: [
      { text: "Manage", path: "/admin/live_sessions", icon: Settings },
    ]
  }
</script>

<Page {...pageProps}>

  {#snippet buttons()}
    {#if user?.has_active_membership}
      <AutoEnroll />
    {/if}
  {/snippet}

  <FilterBar {pagination} paginationProps={{ summary: true, terms: ["live session", "live sessions"] }}>
    {#snippet filters()}

      <!-- Sort -->
      <Dropdown buttonProps={{ text: sort.label, Icon: sort.icon, variant: "outline", size: "md" }} width="12rem" align="start" itemSize="md">
        {#snippet contents(item)}
          {#each sort.items as sortItem (sortItem.value)}
            {@render item({ text: sortItem.label, icon: sortItem.icon, onSelect: () => sort.setValue(sortItem.value) })}
          {/each}
        {/snippet}
      </Dropdown>

      <!-- Status -->
      <Dropdown buttonProps={{ text: status.label, Icon: status.icon, variant: "outline", size: "md" }} width="16rem" align="start" itemSize="md">
        {#snippet contents(item)}
          {#each status.items as statusItem (statusItem.value)}
            {@render item({ text: statusItem.label, icon: statusItem.icon, onSelect: () => status.setValue(statusItem.value) })}
          {/each}
        {/snippet}
      </Dropdown>

      <!-- Tag filter -->
      {#if tags.length > 0}
        <Dropdown buttonProps={{ text: tag.label, Icon: TagIcon, variant: "outline", size: "md" }} width="16rem" align="start" itemSize="md">
          {#snippet contents(item)}
            {#each tag.items as tagItem (tagItem.value)}
              {@render item({ text: tagItem.label, icon: tagItem.icon, onSelect: () => tag.setValue(tagItem.value) })}
            {/each}
          {/snippet}
        </Dropdown>
      {/if}

      <!-- Registration status (only for premium users who can enroll) -->
      {#if user?.has_active_membership}
        <Dropdown buttonProps={{ text: registration.label, Icon: registration.icon, variant: "outline", size: "md" }} width="16rem" align="start" itemSize="md">
          {#snippet contents(item)}
            {#each registration.items as registrationItem (registrationItem.value)}
              {@render item({ text: registrationItem.label, icon: registrationItem.icon, onSelect: () => registration.setValue(registrationItem.value) })}
            {/each}
          {/snippet}
        </Dropdown>
      {/if}
    
    {/snippet}

  </FilterBar>
  
  <GridView {live_sessions} />

  <Pagination {pagination} paginationProps={{ summary: true, terms: ["live session", "live sessions"] }} />

</Page>

